<!--
 * @Author: crazycattle
 * @Date: 2022-04-13 16:32:16
 * @Description: content
-->
<template>
  <div class="PerforMonthReport">
    <!-- <PageNav :slider="slider" :openMenu="openMenu">
      <el-main>
        <reportTypeTwo :wayString="wayString" :placehold="placehold" :Title="Title"></reportTypeTwo>
      </el-main>
    </PageNav> -->
    <reportPageTemp
      ref="reportPageTemp"
      :reportParams="reportParams"
      :filter="filter"
    >
      <div class="flex-wrap">
        <div class="flex-al mb10 mr10">
          <div class="select-box" style="width:170px;">
            <el-select
              v-model="filter.coursetype_id"
              clearable
              filterable
              :placeholder="
                $t('views.Analysisreport.admTrackReport.51yzwntm4j40')
              "
              @change="filterCourseCat"
            >
              <el-option
                v-for="(item, index) in filterList.coursetypeList"
                :key="index"
                :label="`${item.coursetype_cnname}(${item.coursetype_branch})`"
                :value="item.coursetype_id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <!-- <div class="flex-al mb10 mr10">
          <div class="select-box" style="width:170px;">
            <el-select
              v-model="filter.coursecat_id"
              clearable
              filterable
              placeholder="请选择班种"
              @change="search"
            >
              <el-option
                v-for="(item, index) in filterList.courseCatList"
                :key="index"
                :label="`${item.coursecat_cnname}(${item.coursecat_branch})`"
                :value="item.coursecat_id"
              >
              </el-option>
            </el-select>
          </div>
        </div> -->
      </div>
    </reportPageTemp>
  </div>
</template>
<script>
// import reportTypeTwo from "@/components/report/reportType2";
import reportPageTemp from "@/components/report/tableTemplate";
import http from "../analysisreport.js";
export default {
  name: "analysisreport-PerforMonthReport",
  data() {
    return {
      reportParams: {
        wayString: "getTeachersAdmissions", //传递到子组件的方法名称
        Title: "教师招生分析表",
      },

      filterList: {
        coursetypeList: [],
        courseCatList: [],
      },
      filter: {
        coursetype_id: "",
        coursecat_id: '',
      },
    };
  },
  components: {
    reportPageTemp,
  },
  created() {
    this.courseTypeRecruitApi();
    this.getTypeCourseCatApi()

  },
  methods: {
    //下拉列表->获取班组列表--zjb
    courseTypeRecruitApi() {
      this.$http.courseTypeRecruitApi({
        coursetype_isrecruit: 1
      }).then((res) => {
        if (res.data.code === 200) {
          this.filterList.coursetypeList = res.data.data.list;
        } else {
          this.filterList.coursetypeList = [];
        }
      });
    },
     filterCourseCat() {
      this.filter.coursecat_id = "";
      this.getTypeCourseCatApi();
      this.search()
    },
    getTypeCourseCatApi() {
      this.$http
        .getTypeCourseCatApi({
          coursetype_id: this.filter.coursetype_id,
        })
        .then((res) => {
          const { code, data: _jb } = res.data;

          const data = _jb;
          if (code === 200) {
            this.filterList.courseCatList = data.list;
          } else {
            this.filterList.courseCatList = [];
          }
        });
    },
    search() {
      this.$refs.reportPageTemp.search();
    },
  },
};
</script>
<style lang="less">
@import url("../../../assets/less/manage.less");
@import url("../analysisreport.less");
.PerforMonthReport {
  // height: 100vh;
  font-size: 20px;
}
</style>
